let React = require("react");
 
 class Spinning extends React.Component {

    constructor(){
        super();

        this.onClose = this.onClose.bind(this);
    }
    
    onClose(){
        if(this.props.hasClose){
            this.props.onClose();
        }
    }

    render() {
        const { hasClose = false, show, showThrobber = true } = this.props;
        let element;
        let classShow = show === true? "show": "";
        
        if(this.props.message && this.props.message !== ""){
            element =  (<div className="centerVertical">
                            {showThrobber && <div className="throbber">
                                                <div className="throbber__bounce1"></div>
                                                <div className="throbber__bounce2"></div>
                                                <div className="throbber__bounce3"></div>
                                            </div>}
                            <div className="processing__message">{this.props.message}</div>
                        </div>)
        }else{
            element = this.props.children;
        }
        
        return (
            <div className={`processing ${classShow}`} style={this.props.style} onClick={this.onClose} ref={div => this.processing = div}>
                <div className="container" onClick={ e =>  e.stopPropagation()}>
                    {hasClose && <div className="processing__close" onClick={this.onClose}></div>}
                    {element}
                </div>
            </div>
        );
    }
};
 
module.exports = Spinning;
